module.exports = __webpack_public_path__ + "img/selected0-min.4a89624e.png";